<template>
    <div class="table relativeusers" v-if="!(loading && isMobile)">
        <div><button @click="openAddRelatedUser()" class="add-user-btn"><span class="fa fa-plus" ></span></button> {{'AddRelative' | lang }}</div>
        <div v-if="relativeUsers && relativeUsers.length>0" class="thead">
            <div class="tr">
                <div class="th" scope="col">{{ 'FirstName' | lang }}</div>
                <div class="th" scope="col">{{ 'LastName' | lang }}</div>
                <div class="th" scope="col">{{ 'Relative' | lang }}</div>
                <div class="th" scope="col">{{ 'Status' | lang }}</div>
                <div class="th" scope="col">{{ 'Remove' | lang }}</div>
            </div>
        </div>
        <div class="tbody" style="overflow-y:auto">
            <div v-for="(u, idx) in relativeUsers" :key="idx" class="tr" @click="openDetails(p)">
                <div class="td" :data-label="dictValue('FirstName')">{{u.FirstName}}</div>
                <div class="td" :data-label="dictValue('LastName')">{{u.LastName }}</div>
                <div class="td" :data-label="dictValue('Relative')">{{(u.RelativeType.Label) }}</div>
                <div class="td" :data-label="dictValue('Status')">{{ getLabelStatus(u.IsAvailableLinkUpdateable) }}</div>
                <div class="td" :data-label="dictValue('Remove')">
                    <div style="display: inline-table;">
                        <timed-button v-on:confirm="remove(u)" style="float:left;margin-right:1px" />
                    </div> 
                </div> 
            </div>
            <div slot="loading" v-if="loading" class="tr loading">{{ 'IsLoading' | lang }}</div>
        </div>
    </div> 
    <div v-else-if="loading" class="flexcentered bigger"> 
        {{'IsLoading' | lang}}
    </div>
</template>

<script>
import UserServices from '@/mixins/services/userServices'
import DettaglioAcquisto from '@/dialogs/DettaglioAcquisto'
import AddRelatedUser from '@/dialogs/AddRelatedUser'
import TimedButton from '@/components/TimedButton'
import { create } from 'vue-modal-dialogs'
const DettaglioAcquistoDialogCreator = create(DettaglioAcquisto)
const AddRelatedUserCreator = create(AddRelatedUser)


export default {
    name: 'RelativeUsers',
    mixins: [UserServices],
    components: { TimedButton },

    data() {
        return {
            relativeUsers: [],
            currentDataPromise: null,
            loading: false,
        }
    },
    computed: {

    },
    methods: {

        openDetails(order) {
            DettaglioAcquistoDialogCreator({ order })
        },
        async openAddRelatedUser() {
            let chosen = await AddRelatedUserCreator()
            if (chosen) {
                this.updateData();
            }
        },
        remove(userToRemove) {
            var request = {
                ContextWebApi: {
                    AccessType: this.isMobile ? 'mobile' : 'website',
                    CultureName: this.language,
                    SessionId: this.isLogged ? this.user.Token : null,
                    AccessMode: this.isFullLogged ? 'connectedUser' : 'anonymous',
                    SalesMode: "0",
                    EquipmentReference: this.manifest.custom_CEB
                },

                RelativeUserLinked: {
                    UserCode: userToRemove.UserCode,
                    RelativeType: userToRemove.RelativeType
                },

                RelativeUserLinkedTo: {
                    UserCode: this.user.UserAccountCode,
                    RelativeType: userToRemove.RelativeType
                }
            };

            this._removeRelativeUser(request).then(data => {
                this.updateData();
                this.internalBus.$emit('notify:success', {
                    text: this.dictValue('Saved'),
                    key: this.notifierKey,
                    timeout: 3000
                })
            }).catch(err => {
                this.internalBus.$emit('notify:error', {
                    text: this.dictValue('errorOccured') + (err.status === 418 ? '[VAD]' : ''),
                    key: this.notifierKey,
                    timeout: 3000
                })
            });       
        },
        getLabelStatus(state)
            {          
                var labelStatus="";
                if(state==undefined || state==null)
                {
                    labelStatus=this.dictValue('LinkStatusUnknown');
                }
                else if(state==true)
                {
                    labelStatus=this.dictValue('LinkStatusAccept');
                }
                else
                {
                    labelStatus=this.dictValue('LinkStatusPending');
                }
                return labelStatus;
            },

        updateData() {
            this.loading = true
            this._getRelativeUsers().then(data => {
                this.relativeUsers = data
                this.loading = false
            }).catch(err => {
                this.loading = false
            })
        }
    },
    mounted() {
        this.updateData()
    },
    watch: {
        user() {
            if (this.isFullLogged && this.user) {
                this.updateData()
            }
        }

    }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';
#app.desktop .relativeusers {
    max-height: 30rem;
    margin-top: .5rem;
}

#app.mobile .relativeusers {
    height: 100%;
}

.table .tfoot {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.add-user-btn {
    margin-right: 20px;
    width: fit-content;
}
</style>
